<template>
  <a
    v-tooltip="{
      content: 'Visit URL',
      placement: 'bottom',
      trigger: isOnMobile ? 'click' : 'focus hover',
    }"
    :data-test-id="`tinyurl_${prefix}_visit_btn`"
    :class="['btn btn-outline-teal mr-1 mb-1', size ? `btn-${size}` : ``]"
    :href="url"
    target="_blank"
    aria-label="Visit URL"
  >
    <i class="fa fa-fw fa-share" />
  </a>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "VisitTinyurl",

  props: {
    prefix: {
      type: String,
      required: true,
    },

    size: {
      type: String,
      default: "",
    },

    url: {
      type: String,
      default: "",
    },
  },

  computed: {
    ...mapGetters(["isOnMobile"]),
  },
};
</script>
